import { FormControl } from '@angular/forms';
import { distinctUntilChanged, Observable, startWith } from 'rxjs';

export function valueChanges<T>(control: FormControl<T>, emitOnSubscribe = true): Observable<T> {
    if (emitOnSubscribe) {
        return control.valueChanges.pipe(startWith(control.value), distinctUntilChanged());
    }

    return control.valueChanges.pipe(distinctUntilChanged());
}
